import React from 'react';

export default function OptionImage({
  imageUrl,
  imageUrl2x,
  imageAlt,
  imageHeight,
  imageWidth,
}) {
  return (
    <div className="app-option-image">
      {imageUrl2x
        ? (<img
            alt={imageAlt}
            src={imageUrl}
            srcSet={`${imageUrl2x} 2x`}
            height={imageHeight}
            width={imageWidth}
          />)
        : (<img
            alt={imageAlt}
            src={imageUrl}
            height={imageHeight}
            width={imageWidth}
          />)
      }
    </div>
  )
}
